export type WebsiteName = 'greenvision' | 'gv_charging';
export type TaskStatus = 'idee' | 'in_uitvoering' | 'voltooid';
export type TaskPriority = 'low' | 'medium' | 'high' | 'urgent';
export type ContentStatus = 'concept' | 'review' | 'live';
export type IdeaStatus = 'nieuw' | 'in_overweging' | 'goedgekeurd' | 'afgewezen';

export interface WebsiteTask {
  id: string;
  title: string;
  description: string | null;
  website: WebsiteName;
  status: TaskStatus;
  priority: TaskPriority;
  assigned_to: string | null;
  created_by: string | null;
  due_date: string | null;
  completed_at: string | null;
  labels: string[];
  page_tags: string[];
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  assigned_profile?: {
    display_name: string | null;
    email: string | null;
  };
  created_profile?: {
    display_name: string | null;
    email: string | null;
  };
}

export interface WebsiteContent {
  id: string;
  title: string;
  slug: string;
  website: WebsiteName;
  status: ContentStatus;
  content: string;
  created_by: string | null;
  last_edited_by: string | null;
  published_at: string | null;
  created_at: string;
  updated_at: string;
  created_profile?: {
    display_name: string | null;
    email: string | null;
  };
  editor_profile?: {
    display_name: string | null;
    email: string | null;
  };
}

export interface WebsiteContentVersion {
  id: string;
  content_id: string;
  content: string;
  version_notes: string | null;
  created_by: string | null;
  created_at: string;
  created_profile?: {
    display_name: string | null;
    email: string | null;
  };
}

export interface WebsiteNote {
  id: string;
  note: string;
  website: WebsiteName;
  labels: string[];
  created_by: string | null;
  created_at: string;
  updated_at: string;
  created_profile?: {
    display_name: string | null;
    email: string | null;
  };
}

export interface WebsiteIdea {
  id: string;
  title: string;
  description: string | null;
  website: WebsiteName;
  impact_score: number | null;
  next_step: string | null;
  status: IdeaStatus;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  created_profile?: {
    display_name: string | null;
    email: string | null;
  };
}

export const WEBSITE_LABELS: Record<WebsiteName, string> = {
  greenvision: 'Greenvision',
  gv_charging: 'GV Charging',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  idee: 'Idee',
  in_uitvoering: 'In uitvoering',
  voltooid: 'Voltooid',
};

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: 'Laag',
  medium: 'Medium',
  high: 'Hoog',
  urgent: 'Urgent',
};

export const CONTENT_STATUS_LABELS: Record<ContentStatus, string> = {
  concept: 'Concept',
  review: 'Review',
  live: 'Live',
};

export const IDEA_STATUS_LABELS: Record<IdeaStatus, string> = {
  nieuw: 'Nieuw',
  in_overweging: 'In overweging',
  goedgekeurd: 'Goedgekeurd',
  afgewezen: 'Afgewezen',
};
